import axios from 'axios';
import config from '../../../config';
import Cookies from 'js-cookie';

const baseUrl = config.baseUrl; // URL base de tu API
const updatePlanCompraEndpoint = '/api/financiero/actualizarplandecompras'; // Endpoint para actualizar los planes de compra

// Crear una instancia de Axios con la configuración base
const api = axios.create({
    baseURL: baseUrl,
});

// Interceptor de solicitud para añadir el token de autorización
api.interceptors.request.use(
    (config) => {
        const token = Cookies.get('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

/**
 * Función para actualizar un plan de compras en el backend
 * @param {number} oid - ID del plan de compras a actualizar
 * @param {Object} planCompraData - JSON con la estructura actualizada del plan de compras
 * @returns {Promise<Object>} Respuesta del backend con status y mensaje
 */
export const actualizarPlanCompra = async (oid, planCompraData, initialData) => {
    try {

        const payload = {
            ...planCompraData,
            initialData, // 🔹 Agregamos los datos iniciales dentro del cuerpo
        };

        const response = await api.put(`${updatePlanCompraEndpoint}/${oid}`, payload, {
            headers: {
                'Content-Type': 'application/json',
            },
        });

        return response; // Devuelve los datos del servicio
    } catch (error) {
        console.error('❌ Error al actualizar el plan de compras:', error.response?.data || error.message || error);

        return {
            status: error.response?.status || 500,
            message: error.response?.data?.message || '⚠️ Error al actualizar el plan de compras. Verifique la conexión con el servidor.',
        };
    }
};
